/* -------------------------------------------------------------------------- */
/*                                   TITLES                                   */
/* -------------------------------------------------------------------------- */
const titles = {
	pbs: "Proxmox Backup Server",
	pbs_sync: "PBS sync",
};

/* -------------------------------------------------------------------------- */
/*                                 SELECT TYPE                                */
/* -------------------------------------------------------------------------- */
const selectType = {
	card_bttn: "Konfigurieren",

	// Produkte
	pbs_free: {
		description: "150 GB kostenloser Speicher.",
		disabled_info: "Max. 1 pro Kunde",
		title: "Tuxis PBS - Kostenlos",
	},
	pbs_paid: {
		description: "Vollversion für geschäftliche Anwendungen.",
		disabled_info: "Bezahlte Dienste nicht erlaubt",
		title: "Tuxis PBS",
	},
	pbs_sync: {
		description: "Einen Datastore synchronisieren.",
		disabled_info: "Bezahlte Dienste nicht erlaubt",
		title: "PBS sync",
	},
	price_suffix: "p/M pro",
	title: "Welche Proxmox Backup-Dienst möchten Sie erstellen?",
};

/* -------------------------------------------------------------------------- */
/*                                FORM SECTION                                */

const pbsConfigDescription = `
Bestimmen Sie einen Namen und geben Sie an, wie Sie abgerechnet werden möchten und wann Sie eine Benachrichtigung erhalten möchten.

**Feste Grenze** 
Ihr Datastore wächst nicht automatisch und kann somit voll werden, wenn Sie nicht rechtzeitig vergrößern. Sie können Benachrichtigungen einrichten, um dies zu verhindern. Ihnen wird die tatsächliche Nutzung in Rechnung gestellt. Die Größe des Datastore ist für die Abrechnung nicht relevant.

**Grow as you go**
Ihr Datastore ist nicht begrenzt, sondern wächst automatisch, wenn er fast voll ist. Ihnen wird nur die tatsächliche Nutzung in Rechnung gestellt. Die Größe des Datastore ist für die Abrechnung nicht relevant.
`;

const pbsResellerDescription =
	"Wenn Sie den Datastore mit einem Kunden verknüpfen, erhält dieser Kunde eigene Zugangsdaten, um sich beim Datastore anzumelden.\nAls Reseller haben Sie auch Zugriff auf diesen Datastore mit Ihren eigenen Zugangsdaten.";

const pbsSyncVariantDescription = `

**Tuxis PBS**
Der Datastore, den Sie synchronisieren möchten, ist ein Tuxis PBS-datastore.

**Remote PBS**
Der Datastore, den Sie synchronisieren möchten, befindet sich auf einem PBS an einem anderen Ort.`;

const form = {
	// PBS ALERT
	pbs_alert: {
		alert_pruning: {
			label:
				"(Optional) Senden Sie auch eine E-Mail, wenn Fehlermeldungen zum Pruning angezeigt werden.",
			tip: "Pruning ist eine konfigurierbare Aufgabe eines PBS, um alte Snapshots zu entfernen. Wenn während eines Bereinigungsvorgangs eine Fehlermeldung auftritt, wird diese Fehlermeldung nur dann an die E-Mail-Adresse für PBS-Fehlermeldungen gesendet, wenn dieses Kontrollkästchen aktiviert ist.",
		},
		description:
			"Geben Sie eine E-Mail-Adresse ein, an die Sie die PBS-Fehlermeldungen erhalten möchten, und wählen Sie optional eine Beziehung aus, mit der Sie dieses Konto verknüpfen möchten. Die Verknüpfung einer Relation hat ansonsten keinen Einfluss auf deren Funktion. Sie können auch andere Produkte mit einer Beziehung verknüpfen und so sehen, was eine Beziehung in Gebrauch hat.",
		pbs_error_email_address: {
			helper_text: {
				business_debtor: {
					href: "/company?scroll_to_communication_preferences=true",
					text: "PBS-Fehlermeldungen werden an die oben angegebene E-Mail-Adresse gesendet. Sie können diese E-Mail-Adresse <a>auf der Seite mit den Unternehmensdaten</a> ändern.",
				},
				private_debtor: {
					href: "/account",
					text: "PBS-Fehlermeldungen werden an die oben angegebene E-Mail-Adresse gesendet. Sie können diese E-Mail-Adresse <a>auf der Seite mit den Kontodetails</a> ändern.",
				},
			},
			label: "E-Mail-Adresse für PBS-Fehlermeldungen",
			placeholder: "Zum Beispiel fehler@example.nl",
		},
		relation: {
			label: "Mit Beziehung verknüpfen",
			option: "PBS mit einer Beziehung verknüpfen",
		},
		title: "Weitere Informationen",
	},

	// PBS DATASTORE
	pbs_datastore: {
		datastore_alert: {
			alert_option_auto_expand:
				"Schicken Sie eine Benachrichtigung per E-Mail, wenn der Datastore <strong>mehr als {{value}}</strong> enthält.",
			alert_option_limited_size:
				"Schicken Sie mir eine Warn-E-Mail, wenn der Datastore <strong>weniger als {{value}}</strong> freien Speicherplatz hat.",
			label: "Benachrichtigungen einstellen",
		},
		datastore_config: {
			alert_email_address: {
				helper_text:
					"Schicken Sie eine E-Mail an diese Adresse bei den oben eingestellten Benachrichtigungen.",
				label: "E-Mail-Adresse für Benachrichtigungen",
				placeholder: "Zum Beispiel etwas@domainname.nl",
			},
			auto_expand: {
				label: "Grow as you go",
				tip: "Diese Option kann nur mit bezahlt pbs verwendet werden. \n Ihre Datastore ist nicht begrenzt, sondern wächst automatisch, wenn er fast voll ist. Ihnen wird nur die tatsächliche Nutzung in ganzen TBs in Rechnung gestellt. Die Größe des Datastore ist für die Abrechnung irrelevant.",
			},
			free_version: {
				title: "Datastore Version",
				value: "PBS Free - 150 GB",
			},
			label: "Datastore-Konfiguration",
			limited_size: {
				label: "Feste Grenze für Datastore",
				tip: "Ihr Datastore wächst nicht automatisch und kann somit voll werden wenn Sie nicht rechtzeitig vergrößern. Sie können Benachrichtigungen einrichten, um dies zu verhindern. Ihnen wird die tatsächliche Nutzung in ganzen TBs in Rechnung gestellt. Die Größe des Datastore ist für die Abrechnung irrelevant.",
			},
		},

		datastore_info: {
			description: {
				placeholder: "Optionale Beschreibung",
			},
			label: "PBS Datastore-Info",
			name: {
				helper_text: "Geben Sie dem Datastore einen passenden Namen",
				placeholder: "Zum Beispiel „Produktion“",
			},
		},
		datastore_limit: {
			alert_info_free: "Bei einem kostenlosen PBS-Konto kann die Grenze nicht geändert werden.",
			alert_info_paid:
				"Ihre Abrechnung basiert auf der tatsächlichen Nutzung, aufgerundet auf den nächsten ganzen Terabyte. Mit Ihrer aktuellen Grenze wird nie mehr als <strong>{{value}}</strong> abgerechnet.",
			label: "Datastore-Grenze einstellen",
		},
		description: pbsConfigDescription,
		title: { pbs: "Konfiguration", pbs_sync: "Konfiguration Ziel-PBS" },
	},

	// PBS location
	pbs_location: {
		description:
			"Hier können Sie auswählen, in welchem Land und in welcher Stadt Ihre Daten gespeichert werden sollen. So können Sie sicherstellen, dass Ihre Backups weit entfernt von Ihren Live-Daten sind.",
		no_locations:
			"Aktuell ist keine Kapazität verfügbar, sie wird derzeit erweitert. Für aktuelle Informationen folgen Sie uns auf der [Ankündigungss](https://support.tuxis.nl/en/announcements) oder auf [LinkedIn](https://nl.linkedin.com/company/tuxis-internet-engineering)",
		no_locations_free: "In diesem Land kann derzeit kein kostenloses PBS erworben werden.",
		no_locations_paid: "In diesem Land kann derzeit kein kostenpflichtiges PBS erworben werden.",
		select_country: "Wählen Sie ein Land",
		select_invalid: "Wählen Sie einen gültigen PBS-Serverstandort",
		select_location: "Wählen Sie einen Serverstandort",
		source_and_destination_location_identical:
			"Es ist nicht erlaubt, eine PBS-Synchronisierung am selben Speicherort wie die Quell-PBS zu konfigurieren.",
		title: {
			pbs: "PBS-Serverstandort",
			pbs_sync: "Standort Ziel-PBS",
		},
	},

	// PBS RESELLER (USING PBS ALERT TEXT FOR MOST COMPONENTS)
	pbs_reseller: {
		description:
			"Geben Sie eine E-Mail-Adresse ein, an die Sie die PBS-Fehlermeldungen erhalten möchten, und wählen Sie optional eine Beziehung aus, mit der Sie dieses Konto verknüpfen möchten. Die Verknüpfung einer Relation hat ansonsten keinen Einfluss auf deren Funktion. Sie können auch andere Produkte mit einer Beziehung verknüpfen und so sehen, was eine Beziehung in Gebrauch hat.",
		relation: {
			info: "Falls der Kunde noch keine Zugangsdaten für den ausgewählten PBS-Standort hat, sind die Zugangsdaten 30 Tage lang im Passwort-Tresor sichtbar.",
		},

		reseller_mode: {
			info: pbsResellerDescription,
			option_list: ["Eigener Gebrauch", "Für einen Kunden"],
			title: "Datastore bereitstellen für",
		},
		title: "Reseller-Einstellungen",
	},

	// PBS SOURCE SELECTOR
	pbs_source_selector: {
		autocomplete: {
			helper_text: "Kostenlose Datastores sind von der Auswahl ausgeschlossen",
			label: "PBS",
			placeholder: "Vorhandenen Datastore auswählen",
			title: "Wählen Sie einen Ihrer vorhandenen Datastores aus",
		},
		description: "Wählen Sie den Quell-Datastore aus, den Sie synchronisieren möchten.",
		title: "Quell-Datastore auswählen",
	},

	// PBS REMOTE SOURCE SELECTOR
	pbs_source_selector_remote: {
		description: "Konfigurieren Sie die PBS-Quelle, von der Sie synchronisieren möchten.",
		// REMOTE HOST
		remote_host: {
			host: {
				label: "Remote Hostname",
				placeholder: "Zum Beispiel 'pbs.example.com'",
			},
			port: {
				label: "Remote PBS-Port",
				placeholder: "Zum Beispiel '8007'",
			},
			source_datastore_name: {
				label: "Datastore-Name",
				placeholder: "Zum Beispiel 'datastore_remote'",
			},
			title: "Remote-Host konfigurieren",
		},

		// REMOTE HOST CREDENTIALS
		remote_host_credentials: {
			title: "Zugangsdaten des Remote-Hosts",
			token_name: {
				label: "Token-Name",
				placeholder: "Token-Namen eingeben",
			},
			token_secret: {
				label: "Token-Geheimnis",
				placeholder: "Token-Geheimnis eingeben",
			},
			user_name: {
				label: "Benutzername",
				placeholder: "Zum Beispiel 'username@pbs'",
			},
		},

		// FINGER PRINT
		ssl_fingerprint: {
			checkbox: {
				label: "Der PBS-Host verwendet ein selbstsigniertes Zertifikat",
				tooltip:
					"Der SSL-Fingerabdruck wird beim Aufbau einer sicheren Verbindung überprüft. Bei einem selbstsignierten Zertifikat ist dies ein Pflichtfeld, bei einem offiziellen Zertifikat ist es optional. [Weiterlesen.](https://pbs.proxmox.com/docs/sysadmin.html#certificate-management)",
			},
			ssl_fingerprint: {
				placeholder: "SSL-Fingerabdruck eingeben",
			},
			title: "SSL-Fingerabdruck",
		},

		// BUTTONS
		test_button: "Verbinding testen",
		test_success: "Verbindung erfolgreich getestet",
		test_tooltip:
			"Dies ist ein optionaler Test. Dieser Test überprüft die von Ihnen eingegebenen Daten, um sicherzustellen, dass Sie diese korrekt eingegeben haben. \n Es kann sein, dass dieser Test nicht funktioniert, wenn auf Ihrem Host eine Whitelist eingerichtet ist. In diesem Fall können Sie jedoch einfach einen pbs-sync erstellen.",
		title: "Quell-PBS-Informationen",
	},
	// PBS SYNC VARIANT
	pbs_sync_variant: {
		description: pbsSyncVariantDescription,
		option_list: {
			remote_pbs: "Remote PBS",
			tuxis_pbs: "Tuxis PBS",
		},
		title: "Quell-PBS",
	},
	// PBS TYPE
	pbs_type: {
		description:
			"Die kostenlose Version ist für jeden verfügbar. Nur Unternehmen und niederländische Privatpersonen können die kostenpflichtige Version erwerben.",
		title: "Tuxis PBS Version",
	},

	// PBS SYNC INTERVAL
	schedule: {
		description:
			"Geben Sie an, wie oft Sie den Datastore mit dem Zieldatastore synchronisieren möchten.",
		option_list: {
			day_1: "Einmal pro Tag",
			day_4: "4 Mal pro Tag",
			day_12: "12 Mal pro Tag",
		},
		select: {
			helper_text: "Synchronisationsintervalle können aktualisiert werden.",
			label: "Intervall",
			placeholder: "Intervall auswählen",
			title: "Intervall auswählen",
		},
		title: "Synchronisationsintervall",
	},

	submit_button: "Konfiguration überprüfen",
};

/* -------------------------------------------------------------------------- */
/*                                CONFIRM PAGE                                */
/* -------------------------------------------------------------------------- */
const confirm = {
	config: {
		alert_email_address: "E-Mail-Adresse für Benachrichtigungen:",
		alert_info:
			"Wir berechnen den höchsten gemessenen Speicherpeak während des Monats und runden ihn auf einen ganzen Terabyte auf.",
		alert_send_by: {
			label: "Senden Sie Benachrichtigungen für",
			list: [
				"Fehler im Proxmox Backup Server",
				"Wenn <strong>{{value}}</strong> Speicher übrig bleibt",
				"Wenn <strong>{{value}}</strong> Speicher erreicht wird",
				"Fehler beim Pruning",
			],
		},
		datastore_config: "Datastore-Konfiguration:",
		description: "Sehen Sie hier die Übersicht über das von Ihnen bestellte PBS",
		fingerprint: "SSL-Fingerabdruck",
		host: "Remote PBS-Hostname",
		location: "PBS-Serverstandort:",
		pbs_source_selector: "Ausgewählter Tuxis PBS",
		pbs_sync_variant: "Quell-PBS",
		pbs_type: "PBS-Version:",
		port: "Remote PBS-Port",
		price_discount: "Ihr Rabatt",
		price_exc_vat: "Exkl. MwSt",
		price_line_pbs: "Pro Terabyte €{{value}} p/M",
		price_line_pbs_sync: "€{{value}} p/M",
		price_pbs: "Preis PBS:",
		price_pbs_sync: "Preis PBS sync",
		relation: "Verknüpfte Beziehung:",
		schedule: "Synchronisationsintervall",
		source_datastore_name: "Remote-Datastore-Name",
		title: "Konfigurationsübersicht",
		token_name: "Token-Name",
		token_secret: "Token-Geheimnis",
		user_name: "Benutzername",
	},

	info: {
		description: {
			label: "Beschreibung (optional)",
			placeholder: "Optionale Beschreibung",
		},
		name: {
			label: "Name des Datastore",
			placeholder: "Zum Beispiel 'Produktion'",
		},
		purchase_order_number: {
			helper:
				"Wenn Sie eine Bestellnummer eingeben, wird dieser Dienst immer separat in Rechnung gestellt und die Bestellnummer auf der Rechnung aufgeführt.",
			label: "Bestellnummer (optional)",
			placeholder: "Zum Beispiel '1-2344-3949-3'",
		},
		text: "Nehmen Sie hier gegebenenfalls notwendige Änderungen an den PBS-Details vor.",
		title: "PBS Details",
	},

	product_details: {
		pbs: "Proxmox Backup Service",
		pbs_edit: "Proxmox Backup Service – Aktualisieren",
		pbs_free: "Proxmox Backup Service – Kostenlos (150GB)",
		pbs_sync: "PBS-Synchronisation",
		pbs_sync_edit: "PBS-Synchronisation – Aktualisieren",
		title: "Produktübersicht",
	},
	status_messages: {
		no_nodes_available:
			"Leider ist an diesem Standort derzeit keine Kapazität verfügbar. Versuchen Sie einen anderen Standort oder kontaktieren Sie den Support.",
		success:
			"Ihr neues PBS wurde erfolgreich erstellt! Die Anmeldeinformationen finden Sie im Passwort-Tresor.",
	},
	title: "Bestellübersicht",
};
const create = {
	confirm: confirm,
	form: form,
	select_type: selectType,
	titles: titles,
};

export default create;
